export const USER_ROLES = {
  ADMIN: "admin",
  STORE: "store",
};
